import sanityClient from '@sanity/client'

export default sanityClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: 'development', //process.env.NODE_ENV,
  apiVersion: '2021-09-27',
  useCdn: process.env.NODE_ENV == 'production',
  token: process.env.SANITY_TOKEN,
})
